import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=27fca070"
import script from "./Memory.vue?vue&type=script&lang=ts"
export * from "./Memory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports